
import React from 'react';
import SingleBedsheetImage from '../images/single-bedsheet.jpg';
import './SingleBedsheetDetail.css';

function SingleBedsheetDetail() {
    return (
        <div className="single-bedsheet-detail">
            <h1>White Fitted Single Bedsheet - Perfect for Every Bedroom</h1>
            <img src={SingleBedsheetImage} alt="Elegant white fitted single bedsheet" />
            <h2>Product Features</h2>
            <p>Premium White Fitted Single Bedsheets – Soft, Durable & Stylish

               Upgrade your sleep experience with our luxurious white fitted single bedsheets, expertly designed for a perfect fit and long-lasting comfort. Made from high-quality, breathable, and hypoallergenic fabric, these bedsheets are ideal for everyday use—combining elegance, practicality, and durability. The sleek, minimalist design adds a touch of sophistication to any bedroom, while the ultra-soft texture ensures a restful night’s sleep, wash after wash.

               Whether you're refreshing your bedding essentials or enhancing your guest room, our premium single bedsheets deliver the ideal blend of style and comfort.
            </p>
        </div>
    );
}

export default SingleBedsheetDetail;

